<template>
  <div class="concierge-option panels">
    <div class="panel-left-flex">
      <h3>Requirements</h3>
      <div class="form-section">
        <label>How many people are traveling?</label>
        <select v-model="pax">
          <option v-for="n in 8" :key="n" :value="n">{{ n }} {{ n == 1 ? "person" : "people" }}</option>
          <option disabled>For more than 8, please select Group trip</option>
        </select>
      </div>
      <div class="form-section">
        <label>What bookings do you need?</label>
        <div class="checkboxes">
          <div class="checkboxlabel" :class="{ on: itemsIsFlights === true }" @click="itemsIsFlights = !itemsIsFlights">
            <div class="checkbox" />
            <label>Flights</label>
          </div>
          <div class="checkboxlabel" :class="{ on: itemsIsHotels === true }" @click="itemsIsHotels = !itemsIsHotels">
            <div class="checkbox" />
            <label>Hotels</label>
          </div>
          <div class="checkboxlabel" :class="{ on: itemsIsTransport === true }" @click="itemsIsTransport = !itemsIsTransport">
            <div class="checkbox" />
            <label>Transport</label>
          </div>
          <div class="checkboxlabel" :class="{ on: itemsIsOther === true }" @click="itemsIsOther = !itemsIsOther">
            <div class="checkbox" />
            <label>Other</label>
          </div>
        </div>
      </div>
      <div v-if="itemsIsFlights" class="form-section">
        <label>Flights: What are your dates, places and preferences?</label>
        <textarea v-model="detailsFlights" />
      </div>
      <div v-if="itemsIsHotels" class="form-section">
        <label>Hotels: What are your dates, places and preferences?</label>
        <textarea v-model="detailsHotels" />
      </div>
      <div v-if="itemsIsTransport" class="form-section">
        <label>Transport: What are your dates, places and preferences?</label>
        <textarea v-model="detailsTransport" />
      </div>
      <div v-if="itemsIsOther" class="form-section">
        <label>Other: What are your dates, places and preferences?</label>
        <textarea v-model="detailsOther" />
      </div>
      <button :disabled="isLoading" @click="submit">Create Trip Request</button>
    </div>
    <FAQ
      class="panel-right-40-percent"
      :faqs="[
        {
          question: 'How is concierge different to automated?',
          answer: 'With a concierge trip request, a human travel expert will find the best options, answer any questions and help book your entire trip.',
        },
        {
          question: 'What trips suit the concierge service?',
          answer: 'Any complex or uncertain trip. We will discuss options, provide recommendations and make sure we book exactly what you want.',
        },
        {
          question: 'What happens next?',
          answer: 'Once you submit this form, we will allocate your request to the most suitable travel expert. They will reply within the hour.',
        },
      ]"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import Trip from "../classes/trip.js";
import FAQ from "../components/common/FaqPanel.vue";

const emit = defineEmits(["createTrip"]);

const isLoading = ref(false);
const pax = ref(1);

const itemsIsFlights = ref(true);
const itemsIsHotels = ref(true);
const itemsIsTransport = ref(false);
const itemsIsOther = ref(false);
const items = computed(() => {
  var req = [];
  if (itemsIsFlights.value) {
    req.push("Flights");
  }
  if (itemsIsHotels.value) {
    req.push("Hotels");
  }
  if (itemsIsTransport.value) {
    req.push("Transport");
  }
  if (itemsIsOther.value) {
    req.push("Other");
  }
  return req.join(", ");
});

const detailsFlights = ref(null);
const detailsHotels = ref(null);
const detailsTransport = ref(null);
const detailsOther = ref(null);
const details = computed(() => {
  var req = [];
  if (itemsIsFlights.value) {
    req.push("Details (Flights): " + (detailsFlights.value ? detailsFlights.value : "NA"));
  }
  if (itemsIsHotels.value) {
    req.push("Details (Hotels): " + (detailsHotels.value ? detailsHotels.value : "NA"));
  }
  if (itemsIsTransport.value) {
    req.push("Details (Transport): " + (detailsTransport.value ? detailsTransport.value : "NA"));
  }
  if (itemsIsOther.value) {
    req.push("Details (Other): " + (detailsOther.value ? detailsOther.value : "NA"));
  }
  return req.join("\n");
});

const description = computed(() => {
  var desc = "Concierge Trip\n\n";
  desc += "Travelers: " + pax.value + "\n";
  desc += "Required: " + items.value + "\n";
  desc += details.value;
  return desc;
});

const submit = () => {
  isLoading.value = true;
  const trip = new Trip();
  trip.description = description.value;
  trip.isSelfBook = false;
  emit("createTrip", trip);
};
</script>
